// extracted by mini-css-extract-plugin
module.exports = {"container":"persistentStream__container___nl3w8","is-hidden-full-screen-btn":"persistentStream__is-hidden-full-screen-btn___2U24L"};